<template>
<div>
	<el-card class="box-card" :label="title" shadow="hover">
		<div slot="header" class="clearfix">
			<span>{{title}}</span>
		</div>
		<div v-for="(i, idx) in setlist">
			<el-form-item
				v-if="
					(i.controltype == 'text' || 'textarea' || 'select' || 'checkbox' || 'combox-checkbox') &&
						i.controltype != 'table' &&
						i.ishidden == 'False'
				"
				:label="i.showname"
				label-width="80px"
				size="mini"
			>
				<el-input
					:ref="i.colname"
					v-model="i.value"
					type="i.controltype"
					:style="{ width: `${i.coltdwidth}px` }"
					v-if="(i.controltype == 'text' || i.controltype == 'textarea') && i.ishidden == 'False'"
					@keyup.native="val => enterinput(val, i, index)"
				></el-input>
				<el-select
					:ref="i.colname"
					v-model="i.value"
					v-if="i.controltype == 'select' && i.ishidden == 'False'"
					:style="{ width: `${i.coltdwidth}px` }"
					@keyup.native="val => enterinput(val, i, index)"
				>
					<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
				</el-select>
				<label v-if="i.controltype == 'checkbox' && i.ishidden == 'False'">
					<el-checkbox
						:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
						v-model="i.value"
						:true-label="1"
						:false-label="0"
						:ref="i.colname"
						:checked="i.value"
						@change="val => setcheck(val, i)"
					></el-checkbox>
				</label>
				<div v-if="i.controltype == 'combox-checkbox' && i.ishidden == 'False'">
					<el-checkbox
						:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
						true-label="1"
						false-label="0"
						:ref="i.colname"
						:checked="i.value != '' && i.value != '0.00' ? true : false"
					></el-checkbox>
				</div>
				<div  v-if="i.controltype == 'addedservice_sign-insured'">
					<div v-for="(it,itx) in i.addedservice" :key="itx">
						<div v-if="it.d_name == '保价'">
							<el-checkbox
								style="width:80px"
								:ref="it.d_name + '_' + index + '_checked'"
								:checked="it.ischecked"
								v-model="it.ischecked"
								@change="val => checkchange(val, it.d_name + '_' + index, i,index)"
							>
								{{ it.label }}
							</el-checkbox>
							<span style="margin-left:50px" v-if="it.ischecked">{{it.factprice}}</span>
						</div>
						<label v-else>
							<el-checkbox style="width:200px" v-model="it.ischecked" :checked="it.ischecked">{{ it.label }}</el-checkbox>
						</label>
					</div>
				</div>
			</el-form-item>
						
		</div>
	 </el-card>
</div>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	props: {
		title:{
			type: String,
			default:''
		},
		l_mode:{
			type: String,
			default:''
		}
	},
	data() {
		return{
			setlist:[],
			orderinfo:{}
		};
	},
	mounted() {
		
	},
	methods:{
		init(param){
			if(param.orderinfo!=undefined)
				this.orderinfo=param.orderinfo;
			this.GetPageLayOut();
		},
		GetPageLayOut(){
			
		}
	},
}	
</script>

<style>
</style>
